export const getAttributeBasedTitle = (isAttributeBased, questionAttributes, attributes = []) => {
  if (!isAttributeBased || !questionAttributes) {
    return '';
  }
  const selectedAttributes = {};
  questionAttributes.forEach(({ attributeId, attributeValue }) => {
    const matchedAttribute = attributes.find((attribute) => attribute.id === attributeId);
    if (!matchedAttribute) return;
    if (!selectedAttributes[matchedAttribute.name]) {
      selectedAttributes[matchedAttribute.name] = [attributeValue];
    } else {
      selectedAttributes[matchedAttribute.name].push(attributeValue);
    }
  });
  const titles = Object.entries(selectedAttributes).map(([attributeName, attributeValues]) => {
    return `${attributeName}: ${attributeValues.join(', ')}`;
  });
  return titles.join('; ');
};
